export interface Toast {
  id: number
  message: string
  /** Smaller second line (e.g. which earlier action Undo will revert). */
  detail?: string
  action?: { label: string; run: () => void }
  timeout: number
}

let seq = 0
let toasts: Toast[] = []
const subs = new Set<() => void>()
const timers = new Map<number, ReturnType<typeof setTimeout>>()

function emit() {
  for (const f of subs) f()
}

export const toastStore = {
  get: () => toasts,
  subscribe: (fn: () => void) => {
    subs.add(fn)
    return () => subs.delete(fn)
  },
}

/** One toast at a time: a new one replaces whatever is showing. */
export function showToast(message: string, opts: { action?: Toast['action']; timeout?: number; detail?: string } = {}): number {
  const id = ++seq
  const t: Toast = { id, message, timeout: opts.timeout ?? 6000, ...(opts.action ? { action: opts.action } : {}), ...(opts.detail ? { detail: opts.detail } : {}) }
  for (const old of toasts) {
    const tm = timers.get(old.id)
    if (tm) clearTimeout(tm)
    timers.delete(old.id)
  }
  toasts = [t]
  emit()
  timers.set(
    id,
    setTimeout(() => dismissToast(id), t.timeout),
  )
  return id
}

export function dismissToast(id: number) {
  const tm = timers.get(id)
  if (tm) clearTimeout(tm)
  timers.delete(id)
  const before = toasts.length
  toasts = toasts.filter((t) => t.id !== id)
  if (toasts.length !== before) emit()
}
